import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/groups/groups.scss";
import { Button, FormControl } from "react-bootstrap";
import axios from "axios";
import { apiHost, encodeQueryData } from "../../api/apiClient";
import queryString from "query-string";
import GroupTable from "./groupTable";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import RoleAccessBadge from "../common/roleAccessBadge";
import { Link } from "react-router-dom";

class Groups extends Component {

  constructor(props) {
    super(props);
    this.state = {
      groupList: [],
      searchText: "",
      customerStatusFilter: "active",
      sortKey: "customerName",
      sortDirection: "asc",
      pageNumber: 1,
      pageSize: 100,
    };
    this.customerId = "";
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    this.customerId = values.customerId || "";
    this.getGroups();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const values = queryString.parse(this.props.location.search);
      this.customerId = values.customerId || "";
      this.setState({
        pageNumber: 1,
        sortKey: this.customerId ? "name" : "customerName",
        sortDirection: "asc",
      });
      this.getGroups();
    }
  }

  setGroupQueryObject = () => {
    let data = {};
    data.customerId = this.customerId;
    data.PageSize = 1000000;
    data.PageNumber = 1;
    data.SortDirection = "asc";
    data.SortString = this.customerId ? "name" : "customer";
    return data;
  };

  getGroups = async () => {
    const query = encodeQueryData(this.setGroupQueryObject());
    const url = `${apiHost}/api/Group/GetAllGroup?${query}`;

    this.props.setErrorMessageAction("");
    this.props.setLoadingPageAction(true);
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({ groupList: response.data });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response && e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
    }
  };

  handleSearch = (searchText) => {
    this.setState({ searchText, pageNumber: 1 });
  };

  handleCustomerStatusFilter = (customerStatusFilter) => {
    this.setState({ customerStatusFilter, pageNumber: 1 });
  };

  handleSort = (sortKey) => {
    this.setState((prevState) => ({
      sortKey,
      sortDirection:
        prevState.sortKey === sortKey && prevState.sortDirection === "asc"
          ? "desc"
          : "asc",
      pageNumber: 1,
    }));
  };

  handlePageSize = (pageSize) => {
    this.setState({ pageSize: parseInt(pageSize), pageNumber: 1 });
  };

  handlePageChange = (pageNumber) => {
    const totalPages = this.getTotalPages();
    const nextPage = Math.max(1, Math.min(pageNumber, totalPages || 1));
    this.setState({ pageNumber: nextPage });
  };

  handleCreateNew = () => {
    const values = queryString.parse(this.props.location.search);
    if (values.customerName) {
      this.props.history.push(
        `/create-new-group?selectedAsset=${values.customerName}&customerId=${values.customerId}`
      );
    } else {
      this.props.history.push("/create-new-group");
    }
  };

  getCustomerStatus = (group) => {
    return (group.customerStatus || "Active").toString().toLowerCase();
  };

  getSearchedGroups = () => {
    const { groupList, searchText } = this.state;
    const search = searchText.trim().toLowerCase();

    if (!search) {
      return groupList;
    }

    return groupList.filter((group) => {
      const searchableText = [
        group.name,
        group.description,
        group.customerName,
        group.customerStatus,
        group.status,
        group.menuPriority,
      ].join(" ").toLowerCase();

      return searchableText.includes(search);
    });
  };

  getStatusCounts = () => {
    return this.getSearchedGroups().reduce(
      (counts, group) => {
        const status = this.getCustomerStatus(group);

        counts.all += 1;

        if (status === "active") {
          counts.active += 1;
        }

        if (status === "disabled" || status === "disable") {
          counts.disabled += 1;
        }

        return counts;
      },
      { all: 0, active: 0, disabled: 0 }
    );
  };

  getStatusFilteredGroups = () => {
    const { customerStatusFilter } = this.state;
    const searchedGroups = this.getSearchedGroups();

    if (customerStatusFilter === "all") {
      return searchedGroups;
    }

    return searchedGroups.filter((group) => this.getCustomerStatus(group) === customerStatusFilter);
  };

  getSortValue = (group, sortKey) => {
    if (sortKey === "dbUpdated" || sortKey === "dbCreated") {
      return group[sortKey] ? new Date(group[sortKey]).getTime() : 0;
    }

    if (sortKey === "menuDefault" || sortKey === "menuPriority") {
      return Number(group[sortKey]) || 0;
    }

    return (group[sortKey] || "").toString().toLowerCase();
  };

  getDisplayGroups = () => {
    const { sortKey, sortDirection } = this.state;
    const direction = sortDirection === "asc" ? 1 : -1;

    return [...this.getStatusFilteredGroups()].sort((a, b) => {
      const aValue = this.getSortValue(a, sortKey);
      const bValue = this.getSortValue(b, sortKey);

      if (aValue < bValue) {
        return -1 * direction;
      }

      if (aValue > bValue) {
        return 1 * direction;
      }

      return 0;
    });
  };

  getTotalPages = () => {
    return Math.max(1, Math.ceil(this.getDisplayGroups().length / this.state.pageSize));
  };

  getPagedGroups = () => {
    const { pageNumber, pageSize } = this.state;
    const start = (pageNumber - 1) * pageSize;

    return this.getDisplayGroups().slice(start, start + pageSize);
  };

  render() {
    const values = queryString.parse(this.props.location.search);
    const { searchText, customerStatusFilter, sortKey, sortDirection, pageNumber, pageSize } = this.state;
    const displayGroups = this.getDisplayGroups();
    const pagedGroups = this.getPagedGroups();
    const totalPages = this.getTotalPages();
    const totalItems = displayGroups.length;
    const entryStart = totalItems === 0 ? 0 : (pageNumber - 1) * pageSize + 1;
    const entryEnd = Math.min(pageNumber * pageSize, totalItems);
    const pageSizes = [50, 100, 200];
    const statusCounts = this.getStatusCounts();
    const customerStatusFilters = [
      { key: "all", label: "All", count: statusCounts.all },
      { key: "active", label: "Active", count: statusCounts.active },
      { key: "disabled", label: "Disabled", count: statusCounts.disabled },
    ];

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Groups</title>
          </Helmet>

          <div className="contentBody">
            <div className="contentWrapper group-page">
              <div className="group-page-header">
                <div>
                  <h2>Groups</h2>
                  <p>Manage group records, customer ownership, menu order and status.</p>
                  {values.customerId && (
                    <Link
                      className="group-filter-pill"
                      onClick={() => localStorage.removeItem("customer")}
                      to="/groups"
                    >
                      <i className="fa fa-times"></i>
                      {values.customerName}
                    </Link>
                  )}
                </div>
                <div className="group-header-actions">
                  <RoleAccessBadge role="SystemAdmin" />
                  <Button className="group-create-button" variant="primary" onClick={() => this.handleCreateNew()}>
                    <i className="fa fa-plus"></i>
                    Create new
                  </Button>
                </div>
              </div>

              <div className="group-toolbar">
                <div className="group-search">
                  <i className="fa fa-search"></i>
                  <FormControl
                    aria-label="Search groups"
                    onChange={(e) => this.handleSearch(e.target.value)}
                    placeholder="Search groups, customers, status or sequence"
                    value={searchText}
                  />
                  {searchText && (
                    <button onClick={() => this.handleSearch("")} type="button">
                      <i className="fa fa-times"></i>
                    </button>
                  )}
                </div>
                <div className="group-status-filter" aria-label="Active customer filter">
                  <span>Active customer filter</span>
                  <div>
                    {customerStatusFilters.map((filter) => (
                      <button
                        className={customerStatusFilter === filter.key ? "active" : ""}
                        key={filter.key}
                        onClick={() => this.handleCustomerStatusFilter(filter.key)}
                        type="button"
                      >
                        {filter.label}
                        <strong>{filter.count}</strong>
                      </button>
                    ))}
                  </div>
                </div>
              </div>

              <div className="group-table-shell">
                <GroupTable
                  GroupList={pagedGroups}
                  onSort={this.handleSort}
                  sortDirection={sortDirection}
                  sortKey={sortKey}
                />
              </div>
              <div className="group-pagination">
                <div>
                  Showing <strong>{entryStart}</strong> to <strong>{entryEnd}</strong> of{" "}
                  <strong>{totalItems}</strong> groups
                </div>
                <div className="group-pagination-actions">
                  <label>
                    Rows
                    <select value={pageSize} onChange={(e) => this.handlePageSize(e.target.value)}>
                      {pageSizes.map((size) => (
                        <option key={size} value={size}>{size}</option>
                      ))}
                    </select>
                  </label>
                  <button
                    disabled={pageNumber <= 1}
                    onClick={() => this.handlePageChange(pageNumber - 1)}
                    type="button"
                  >
                    Previous
                  </button>
                  <span>
                    Page <strong>{pageNumber}</strong> of <strong>{totalPages}</strong>
                  </span>
                  <button
                    disabled={pageNumber >= totalPages}
                    onClick={() => this.handlePageChange(pageNumber + 1)}
                    type="button"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Groups);
